export default "__VITE_ASSET__y8S9BHrA__"